<template>
  <detail-section title="Applicant" :editable="editable" :commit="commit">
    <template #default="{isEditing}">
      <template v-if="!isEditing">
        <div class="section-content">
          <!-- Name -->
          <div v-for="owner in (license.contact?.owners || [])" :key="owner">
            {{ formatName(owner, 'all', 1) }}
          </div>
          <div v-if="(license.contact?.owners || []).length === 0" class="text-muted small">(No name)</div>
          <!-- Mailing address -->
          <div v-for="(line, i) in mailingAddressLines" :key="`address_line_${i}`">
            {{ line }}
          </div>
          <div v-if="mailingAddressLines.length === 0" class="text-muted small">(No mailing address)</div>
        </div>
        <div class="section-content">
          <!-- Email -->
          <a
            v-if="license.contact?.email"
            :href="safeHref(`mailto:${license.contact.email}`)"
            target="_blank"
            class="section-action"
            title="Send email"
            aria-label="Send email"
           rel="noopener noreferrer">
            {{ license.contact?.email }}
          </a>
          <!-- Phone -->
          <a
            v-if="license.contact?.phone"
            :href="safeHref(`tel:${license.contact.phone}`)"
            class="section-action"
            title="Call"
            aria-label="Call"
          >
            {{ formatPhone(license.contact?.phone) }}
          </a>
        </div>
      </template>
      <template v-else>
        <div>
          <div class="section-label">Name(s)</div>
          <b-textarea v-model="names" :min-rows="1" small />
        </div>
        <div>
          <div class="section-label">Mailing Address</div>
          <b-textarea v-model="address" :min-rows="2" small />
        </div>
        <div>
          <div class="section-label">Email</div>
          <input type="email" v-model="email" class="form-control form-control-sm" />
        </div>
        <div>
          <div class="section-label">Phone Number</div>
          <phone-input v-model="phone" small />
        </div>
      </template>
    </template>
  </detail-section>
</template>

<script>
import { safeHref } from '@/safeRendering';
import DetailSection from "@/components/common/DetailSection.vue";
import {License} from "@/models/License";
import BTextarea from "@/components/common/BTextarea.vue";
import {normalizeAddressLines} from "@/addressFormatting";
import PhoneInput from "@/components/common/PhoneInput.vue";

export default {
  components: {PhoneInput, BTextarea, DetailSection},
  props: {
    license: License,
    editable: Boolean
  },
  data() {
    return {
      names: null,
      address: null,
      email: null,
      phone: null
    };
  },
  watch: {
    license: {
      immediate: true,
      handler() {
        this.names = this.license?.contact?.owners?.join('\n') ?? '';
        this.address = this.license?.contact?.address ?? '';
        this.email = this.license?.contact?.email ?? '';
        this.phone = this.license?.contact?.phone ?? '';
      }
    }
  },
  computed: {
    mailingAddressLines() {
      return normalizeAddressLines(this.license?.contact?.address).filter(Boolean);
    }
  },
  methods: {
    safeHref,

    async commit(note) {
      await this.license.updateContact({
        names: this.names.split(/\n+/g).map(n => n.trim()).filter(Boolean),
        address: this.address,
        email: this.email,
        phone: this.phone,
        note
      });
    }
  }
}
</script>
